import { Component, Input, OnInit } from '@angular/core';
import { RlFile } from '../shared/rl-file';

@Component({
  selector: 'rl-file-display',
  templateUrl: './file-display.component.html',
  styleUrls: ['./file-display.component.scss']
})
export class FileDisplayComponent {

  @Input() file : RlFile;
  @Input() preview : boolean; //uploadToAmazon
  @Input() allowDelete : boolean = true;

  notAllowDeleteReason : string;
  constructor() { }

  delete(){
    
  }
}
